import { render, staticRenderFns } from "./TermAndCondition.vue?vue&type=template&id=6ceff511"
import script from "./TermAndCondition.vue?vue&type=script&lang=js"
export * from "./TermAndCondition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports